import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import maplibregl from 'maplibre-gl';
// import { flattenToAppURL } from '@plone/volto/helpers';
import 'maplibre-gl/dist/maplibre-gl.css';
import cx from 'classnames';
import './map.css';
import {
  processGJFolder, customIcons, processIPFolder, addTopo, flyTrack
} from './Tour';
// import ScriptTag from 'react-script-tag';
const default_icon = require('./default_icon.png');

const MapLibreView = (props) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const { data } = props;

  let { search } = useLocation();
  let params = new URLSearchParams(search);

  useEffect( () => {
    if (map.current) return; // stops map from intializing more than once
    let API_KEY = data.API_KEY || 'ZQAiVuQPho0lyTvLGp6l';
    var mapStyle = "https://api.maptiler.com/maps/streets-v2/style.json?key=${API_KEY}";
    if ( data.mapStyleURL && data.mapStyleURL.length >= 1 ) {
      mapStyle = data.mapStyleURL[0]['getURL'];
      if ( mapStyle ) {
	mapStyle = '/++api++/'
	  + mapStyle.replace(location.origin, '')
	  + '/@@download/file';
      } else {
	mapStyle = data.mapStyleURL[0]['@id'];
      }
    }
    mapStyle = mapStyle.replace('${API_KEY}', API_KEY);
    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: mapStyle,
      center: [parseFloat(data.lng) || 0, parseFloat(data.lat) || 0],
      bearing:  parseFloat(data.bearing) || 0,
      zoom: parseFloat(data.zoom) || 1,
      pitch: parseFloat(data.pitch) || 0
    });
    addTopo(map.current);
    map.current.addControl(new maplibregl.FullscreenControl(), 'top-right');
      // {container: document.querySelector('html')}
    map.current.addControl(
      new maplibregl.TerrainControl(
	{ source: "terrain_source" }), 'top-right');
    map.current.addControl(
      new maplibregl.NavigationControl({ visualizePitch: true }));
    map.current.addControl(
      new maplibregl.GeolocateControl());
    map.current.addControl(
      new maplibregl.ScaleControl(), 'bottom-right');
    map.current.addControl(
      new maplibregl.ScaleControl({ unit: 'imperial' }), 'bottom-right' );
    map.current.on('click', function(e) {
      console.log('Clicked', e.lngLat);
      if ( map.current.isMoving() ) {
	console.log("moving. Stop");
	map.current._endfly = true;
	map.current.stop();
	return;
      }
      const features = map.current.queryRenderedFeatures(e.point);
      let flyURI =
	location.pathname
	+ '?flylon=' + e.lngLat.lng.toFixed(6)
	+ '&flylat=' + e.lngLat.lat.toFixed(6)
	+ '&flyzom=' + map.current.getZoom().toFixed(2)
	+ '&flybea=' + map.current.getBearing().toFixed(0)
	+ '&flypit=' + map.current.getPitch().toFixed(0);
      if( params.get("onlydat") ) {
	flyURI = flyURI + "&onlydat=" + params.get("onlydat");
      }
      const latlon = e.lngLat.lat.toFixed(6)+','+e.lngLat.lng.toFixed(6);
      let featLI = '';
      if (features && features[0]?.layer?.type == "line") {
        featLI = '<li><a href="' + flyURI
	  + '&flytrk=' + features[0].source
	  + '&flyspd=0.1'
	  + '&flyinc=10'
	  + '">fly track</a></li>';
      }
      if (props.token) { // logged in user
	const popup = new maplibregl.Popup({closeOnClick: true})
              .setLngLat(e.lngLat)
              .setHTML(`<h2>Location</h2>
<ul>
  <li>lat,long = ${latlon} </li>
  <li><a href="http://maps.google.com?q=${latlon}">maps.google.com</a></li>
  <li><a href="${flyURI}">flyto URL</a></li>
  ${featLI}
</ul>`)
              .addTo(map.current);
      }
    });

    if (data.icons && data.icons.length >= 1)
      processIPFolder( map.current, data.icons[0]['getURL']);
    else {
      map.current.on('load', async () => {
	const icon = await map.current.loadImage(default_icon);
	map.current.addImage('photo', icon.data);
      });
    }
    if(params.get('onlydat')) {
      processGJFolder( map.current, params.get('onlydat'));
    } else if(data.geojson) {
      for (const gj of data.geojson) {
	processGJFolder( map.current, gj['getURL']);
      }
    }
    // https://www.npmjs.com/package/@watergis/maplibre-gl-legend
//    map.current.addControl(
//      new MaplibreLegendControl(
//        {}, {showDefault: false, reverseOrder: true} ), "top-left" );

//    var bounds = [[WLng,SLat],[ELng, NLat]];
//    map.current.fitBounds(
//      bounds, {padding: {top: 10, bottom:10, left: 10, right: 10}});

    map.current.on('load', function() {
      let fly = {
	center: [
	  parseFloat(params.get('flylon')),
	  parseFloat(params.get('flylat'))
	],
	pitch: parseFloat(params.get('flypit')) || map.current.getPitch(),
	bearing: parseFloat(params.get('flybea')) || map.current.getBearing(),
	duration: parseFloat(params.get('flydur')) || 8000,
	zoom: parseFloat(params.get('flyzom')) || map.current.getZoom(),
	essential: true
      };
      if (!isNaN(fly.center[0]) && !isNaN(fly.center[1])) {
	map.current.flyTo(fly);
      }
      if (params.get('flytrk')) {
	let trk_src = params.get('flytrk');
	fly.speed = parseFloat(params.get('flyspd')) || 0.1;
	fly.inc =  parseInt(params.get('flyinc')) || 1;
	console.log('flytrk=', trk_src);
	map.current._endfly = false;
	flyTrack(
	  map.current,
	  map.current.getSource( trk_src ),
	  'LineString',
	  fly
	);
      }
    });
  }, [data]);
  
  const updateMapViewData = () => {
    data.lng = map.current.getCenter().lng.toFixed(6);
    data.lat = map.current.getCenter().lat.toFixed(6);
    data.bearing = map.current.getBearing().toFixed(0);
    data.zoom = map.current.getZoom().toFixed(2);
    data.pitch = map.current.getPitch().toFixed(0);
  }

  return <div className={
		cx('block MapLibreView map-wrap align',
		   {
		     center: !Boolean(data.align),
		   },
		   data.align
		  )}
	      style={{ height: data.height || '40vh' }}
	 >
	   <div ref={mapContainer}
		className={
		  cx("map",
		     {'full-width': data.align === 'full', })
		} />
	   <button id='setMapViewDataBtn'
		   onClick={updateMapViewData}
		   style={{ 'border': '1px solid red' }}
	   >
	     Set this as the initial map view
	   </button>
	 </div>;
};

export default MapLibreView;
